interface EmptyStateProps {
    message?: string;
    icon?: string;
}

export function EmptyState({ message = 'Aucune donnée disponible', icon = '📊' }: EmptyStateProps) {
    return (
        <div className="flex flex-col items-center justify-center py-12 text-gray-400">
            <span className="text-4xl mb-3" role="img" aria-label="empty">{icon}</span>
            <p className="text-sm">{message}</p>
        </div>
    );
}
